import { render } from "./plateEdit.vue?vue&type=template&id=42fbaaee&scoped=true"
import script from "./plateEdit.vue?vue&type=script&lang=js"
export * from "./plateEdit.vue?vue&type=script&lang=js"

import "./plateEdit.vue?vue&type=style&index=0&id=42fbaaee&scoped=true&lang=css"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42fbaaee"]])

export default __exports__